import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BackHeader.module.scss';

const ChevronLeftIcon = ({ className }) => (
  <svg
    className={className}
    width='16'
    height='16'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
  >
    <path
      d='M15 18L9 12L15 6'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

const BackHeader = ({
  label = 'Back',
  to,
  onBack,
  right,
  className = '',
  sticky = false,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (typeof onBack === 'function') return onBack();
    if (typeof to === 'string' && to.length)
      return navigate(to, { replace: true });
    return navigate(-1);
  };

  return (
    <div
      className={`${styles.header} ${sticky ? styles.sticky : ''} ${className}`}
    >
      <button
        type='button'
        className={styles.backBtn}
        onClick={handleBack}
        aria-label={label}
      >
        <ChevronLeftIcon className={styles.backIcon} />
      </button>

      <p className={styles.label}>{label}</p>

      {right ? <div className={styles.right}>{right}</div> : null}
    </div>
  );
};

export default BackHeader;
